// extracted by mini-css-extract-plugin
module.exports = {"content":"Success_content__2rMDh","url":"Success_url__2SatY","contentButton":"Success_contentButton__22GtX","firstP":"Success_firstP__2TLbb","secondP":"Success_secondP__1bdbS"};